import { CONFIG } from "@/config";
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.register(
    "/service-worker.js" + CONFIG.SERVICE_WORKER_QUERY_STRING,
  );
}
/* eslint-disable no-new */
// Polyfills
import "core-js/stable";
import "regenerator-runtime/runtime";
import store from "~/store";
import { i18n } from "~/plugins";
import "~/components";
import Vue from "vue";
import App from "./App";
import vuetify from "@/plugins/vuetify"; // path to vuetify export
import router from "./router";
import "../sass/app.sass";
import "vuetify/dist/vuetify.min.css";
import Truncate from "lodash.truncate";

import VuePlyr from "vue-plyr";
import "vue-plyr/dist/vue-plyr.css";
// import vuepaypal from 'paypal-checkout'

import Bugsnag from "@bugsnag/js";
import BugsnagPluginVue from "@bugsnag/plugin-vue";
import VueAnalytics from "vue-analytics";
import Meta from "vue-meta";
import vueAwesomeCountdown from "vue-awesome-countdown";

import VueGtag from "vue-gtag";

const HelloJs = require("hellojs/dist/hello.all.min.js");
const VueHello = require("vue-hellojs");

Bugsnag.start({
  apiKey: CONFIG.BUGSNAG_API_KEY,
  plugins: [new BugsnagPluginVue()],
});

Vue.config.productionTip = false;
Vue.filter("truncate", Truncate);
var SocialSharing = require("vue-social-sharing");

Vue.use(vueAwesomeCountdown, "vac"); // Component name, `countdown` and `vac` by default
Vue.use(SocialSharing);
// Vue.use(babel)
Vue.use(Meta);
Vue.use(VuePlyr);
// Vue.use(vuepaypal)
const bugsnagVue = Bugsnag.getPlugin("vue");
bugsnagVue.installVueErrorHandler(Vue);
Vue.use(
  VueGtag,
  {
    config: { id: CONFIG.G4_ANALYTICS_ID },
  },
  router,
);

HelloJs.init(
  {
    google: CONFIG.GOOGLE_APP_CLIENT_ID,
    facebook: CONFIG.FACEBOOK_APP_CLIENT_ID,
  },
  {
    redirect_uri: "/oauth/callback",
  },
);
Vue.use(VueHello, HelloJs);

// Vue.use(Vuetify)

new Vue({
  el: "#app",
  i18n,
  store,
  router,
  vuetify,
  components: { App },
  template: "<App/>",
});
